module.exports = __webpack_public_path__ + "static/media/Sec-3_2677_Background_Mobile.995b7241.webp";